module.exports = __webpack_public_path__ + "static/media/mind-bottom-middle.dabd09f3.svg";